import { useRef } from 'react';
import { useIsomorphicEffect } from './useIsomorphicEffect';
export function useForwardedRef(ref) {
  var innerRef = useRef(null);
  useIsomorphicEffect(function () {
    if (!ref) return;

    if (typeof ref === 'function') {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  });
  return innerRef;
}